import React, { useRef } from 'react'
import lang from '../utils/language'
import { useDispatch, useSelector } from 'react-redux'
import { API_OPTIONS, Gemini_API_Key } from '../utils/constants'
import { gptSearhResults } from "../utils/gptSlice"
import { GoogleGenerativeAI } from "@google/generative-ai";

//TODO Refactor the code
const GptSearchBar = () => {

  const dispatch = useDispatch()
  const searchText = useRef(null)
   
  const genAI = new GoogleGenerativeAI(Gemini_API_Key);
  //Gemini API call
   const gemini = async () => {

    const model = genAI.getGenerativeModel({ model: "gemini-pro" });
    const prompt = "Act as a movies recommendation system and suggest some movies for the query" + searchText.current.value +
        ". Only Give me 5 movies name , comma separated like the example given ahead. Example: Gadar,Animal,Pathan,Tiger,Jawan"
    

    const result = await model.generateContent(prompt);
    const response = await result.response;
    const text = response.text();
    const moviesArray = text.split(",").map((movie) => movie.trim());
    return moviesArray;
  };

  // Search Movie in TMDB
  const searchMoviesTMDB = async (movie_name) => {
    const movies = await fetch('https://api.themoviedb.org/3/search/movie?query=' + movie_name, API_OPTIONS)
    const json = await movies.json();
    return json.results;
  }

   const handleGPTsearchClick = async () => {
    if(searchText.current.value===""){
      alert("Let us know what do you want to watch today ?")
      return;
    }
    // dispatch(gptSearhResults({ movienames: null, movieResult: null, loading: true }));
    const moviesArray = await gemini();
    const gptMovies = moviesArray;
    const promisArray = gptMovies.map((movie) => searchMoviesTMDB(movie))
    const tmdbResults = await Promise.all(promisArray)
    dispatch(gptSearhResults({ movienames: gptMovies, movieResult: tmdbResults }))

  }

  const langKey = useSelector(store => store.config.lang)

  return (
    <div className='flex justify-center pt-[70%] sm:pt-[15%]'>
      <form className='w-full  sm:w-1/2 grid grid-cols-12' onSubmit={(e) => e.preventDefault()}>
        <input ref={searchText} className='bg-stone-900  border-gray-200 border-2 opacity-90 text-white rounded-full px-8 m-4 col-span-8 sm:col-span-9' type='text' placeholder={lang[langKey].gptSearchPlaceholder} />
        <button onClick={handleGPTsearchClick} className=' col-span-4 sm:col-span-2 px-4 py-4 m-4 
            bg-red-800 text-white rounded-3xl focus:outline-none hover:bg-red-950 focus:ring-4 focus:ring-red-300'>
              {lang[langKey].search} </button>
      </form>
    </div>
  )
}

export default GptSearchBar